export const CREATE_COMMENT_RESPONSE_REQUEST = 'CREATE_COMMENT_RESPONSE_REQUEST';
export const CREATE_COMMENT_RESPONSE_SUCCESS = 'CREATE_COMMENT_RESPONSE_SUCCESS';
export const CREATE_COMMENT_RESPONSE_FAILURE = 'CREATE_COMMENT_RESPONSE_FAILURE';
export const FETCH_COMMENT_RESPONSE_REQUEST = 'FETCH_COMMENT_RESPONSE_REQUEST';
export const FETCH_COMMENT_RESPONSE_SUCCESS = 'FETCH_COMMENT_RESPONSE_SUCCESS';
export const FETCH_COMMENT_RESPONSE_FAILURE = 'FETCH_COMMENT_RESPONSE_FAILURE';